import { StyledRightPanelContent } from "./index.styled";

export default function AppRightPanel() {
  return (
    <StyledRightPanelContent>
      <h3>Right Panel</h3>
      <div className="panel-content">
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam,
          quos.
        </p>
      </div>
    </StyledRightPanelContent>
  );
}
